import { createClient } from '@supabase/supabase-js'
import logger from '../logger';

// CRA utilise les variables d'environnement REACT_APP_*
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://demo.supabase.co'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'demo-key'

// Mode démonstration (données locales, comptes de démonstration) :
// - activé seulement s'il est demandé explicitement (REACT_APP_FORCE_DEV_MODE=true ou REACT_APP_DEMO_MODE=true),
// - ou si aucune clé Supabase réelle n'est configurée.
// Avec de vraies clés et sans demande explicite, le site utilise Supabase (comptes et données réels).
const hasValidCredentials = Boolean(
  process.env.REACT_APP_SUPABASE_URL &&
  process.env.REACT_APP_SUPABASE_ANON_KEY &&
  !/demo\.supabase\.co|your-project/.test(process.env.REACT_APP_SUPABASE_URL) &&
  !/your-anon-key|demo-key/.test(process.env.REACT_APP_SUPABASE_ANON_KEY)
)

const isDevelopmentMode = !hasValidCredentials ||
                         process.env.REACT_APP_FORCE_DEV_MODE === 'true' ||
                         process.env.REACT_APP_DEMO_MODE === 'true'

if (isDevelopmentMode) {
  logger.warn('⚠️ Mode développement actif : Authentification locale simulée.')
  logger.info('📝 Pour utiliser le vrai Supabase :')
  logger.info('   1. Vérifiez REACT_APP_SUPABASE_URL et REACT_APP_SUPABASE_ANON_KEY dans .env')
  logger.info('   2. Définissez REACT_APP_FORCE_DEV_MODE=false')
  logger.info('   3. Redémarrez le serveur (npm start)')
} else {
  logger.info('✅ Connexion à Supabase réel :', supabaseUrl)
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})

export { isDevelopmentMode }
